// extracted by mini-css-extract-plugin
export default {"expandButton":"Spoiler_expandButton__BY1+c","mainContainer":"Spoiler_mainContainer__e6cWf"};